const uz = {
    meta: {
        title: "Biznesni raqamlashtirish talablari 2026: sanalar jadvali",
        description:
            "2026-yilda kuchga kirgan to'rt talab: markirovka kodi chekda, ulgurjida naqd taqiqi, QQS chegarasi va masofaviy tekshiruv. Nima qilish kerak va qancha turadi.",
        keywords: [
            "biznesni raqamlashtirish talablari 2026",
            "2026 yilda biznes uchun yangi qoidalar",
            "markirovka onlayn kassa talablari",
            "elektron hisob-faktura majburiymi",
            "QQS chegarasi 12 000 BHM",
            "soliq riski omillari 2026",
        ],
    },
    h1: "2026-yilda qaysi qonun sizni dasturga majburlaydi va bu qancha turadi",
    lead:
        "Bir yil ichida to'rtta talab birin-ketin kuchga kirdi: markirovka kodi chekda, ulgurjida naqd pul taqiqi, QQS chegarasining ko'tarilishi va masofaviy soliq tekshiruvi. Bu maqolada har bir sana kimga tegishli ekanini, moslashish qancha turishini va qaytimni qanday hisoblashni ko'rib chiqamiz.",
    category: "Qonun va muvofiqlik",
    readingTime: "9 daqiqa",

    body: [
        {
            type: "p",
            text:
                "Har bir talab alohida qaraganda mayda ko'rinadi. Chekka bitta qator qo'shish. To'lovni bankka o'tkazish. Soliq rejimini qayta tekshirish. Birga qaralganda esa ular bitta xulosaga olib keladi: qog'oz daftar va Excel jadvali bilan hisobotni yopib bo'lmaydi.",
        },
        {
            type: "p",
            text:
                "Quyida biznes egasi uchun yagona ko'rinish bor. Qaysi sana, kimga tegishli, nima qilish kerak va qilmasa nima bo'ladi. Barcha raqamlar rasmiy hujjatlarga tayanadi — ularning nomi jadvalda ko'rsatilgan.",
        },

        { type: "h2", text: "2026-yilda nima o'zgardi va bu kimga tegishli?" },
        {
            type: "p",
            text:
                "Asosiy manba — Vazirlar Mahkamasining 2025-yil 23-maydagi ПП-190 qarori. Unga soliq rejimiga oid o'zgarish qo'shildi: 2026-yil 26-mayda imzolangan PF-100 farmoni. Jadvalni chop eting va o'z biznesingizga tegishli qatorlarni belgilang.",
        },
        {
            type: "table",
            head: ["Sana", "Talab", "Kimga tegishli", "Hujjat"],
            rows: [
                [
                    "1-yanvar 2026",
                    "Markirovka buzilishi masofadan, soliq organlari axborot tizimi orqali aniqlanadi. Nazorat uchun Hududlararo soliq inspeksiyasi tashkil etildi",
                    "Markirovka qilinadigan tovar bilan ishlaydigan har kim",
                    "ПП-190",
                ],
                [
                    "1-iyun 2026",
                    "Umumiy soliq tizimiga (QQS) o'tish chegarasi 1 mlrd so'mdan 12 000 BHM — taxminan 5 mlrd so'mgacha ko'tarildi",
                    "Aylanmasi 1–5 mlrd so'm oralig'idagi kompaniyalar",
                    "PF-100 (26.05.2026)",
                ],
                [
                    "1-iyun 2026",
                    "Kofe, sikoriy va ularning ekstraktlari majburiy raqamli markirovkaga kiritildi",
                    "Oziq-ovqat ulgurji va chakana savdosi",
                    "ПП-190",
                ],
                [
                    "1-iyul 2026",
                    "Markirovka kodi onlayn-KKM chekida majburiy aks etadi; ulgurji savdoda hisob-kitob faqat naqdsiz, bank hisob raqamlari orqali",
                    "Chakana do'konlar, distribyutorlar, ulgurji sotuvchilar",
                    "ПП-190",
                ],
                [
                    "1-sentyabr 2026",
                    "Markirovka qoidalarini buzish «yuqori» soliq riski omili hisoblanadi",
                    "Yuqoridagi barcha toifalar",
                    "ПП-190",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Jadvaldagi to'rt sananing uchtasi bitta jarayonga tegadi — tovarning omborga kirishidan chekka tushishigacha bo'lgan yo'l. Ya'ni bu buxgalteriya masalasi emas, operatsion masala.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "1-iyul: chekdagi bitta qator va naqd pulning yo'qolishi" },
        {
            type: "p",
            text:
                "1-iyuldan markirovka qilingan tovar sotilganda uning markirovka kodi onlayn-kassa chekida aks etishi shart. Amalda bu kassaga 2D skaner ulash va kassa dasturining kodni fiskal chekka uzata olishini anglatadi. Eski dasturlarning ko'pchiligida bu funksiya yo'q.",
        },
        {
            type: "p",
            text:
                "Ikkinchi o'zgarish og'irroq: markirovka qilinadigan mahsulot bilan ulgurji savdoda hisob-kitob faqat naqdsiz shaklda, bank hisob raqamlari orqali amalga oshiriladi. Dilerlardan naqd qabul qilib kelgan distribyutor uchun bu butun to'lov modelining almashuvi.",
        },
        {
            type: "list",
            items: [
                "Kassa dasturi markirovka kodini o'qishi va uni chek qatoriga qo'shishi kerak.",
                "Ombor qoldig'i endi «100 dona» darajasida emas, har bir kod darajasida yuritiladi.",
                "Ulgurjidagi har bir to'lov bank o'tkazmasi bo'ladi va elektron hisob-faktura bilan mos kelishi kerak.",
                "Naqd bilan yopilgan «qora» qoldiqlar endi hisobotga sig'maydi — ularni oldindan tartibga solish kerak.",
            ],
        },

        { type: "h2", text: "QQS chegarasining ko'tarilishi yaxshi xabarmi?" },
        {
            type: "p",
            text:
                "2026-yil 1-iyundan umumiy soliq tizimiga o'tish chegarasi 12 000 BHM ga — taxminan 5 mlrd so'mga ko'tarildi. Ilgari 1 mlrd so'm aylanmadan oshgan kompaniya QQS to'lovchisiga aylanardi. Endi bu chegara besh barobar yuqori.",
        },
        {
            type: "p",
            text:
                "Bu ko'p kichik kompaniya uchun yengillik. Lekin u hisobni soddalashtirmaydi. Aylanmangiz chegaraga yaqinlashsa, siz uni oy sayin kuzatishingiz kerak — yil oxirida buxgalter aytib qolsa, kech bo'ladi. Aynan shu sabab aylanmani real vaqtda ko'rsatadigan tizim endi qulaylik emas, ehtiyoj.",
        },
        {
            type: "p",
            text:
                "Yana bir nuqta ko'pincha e'tibordan chetda qoladi. Chegara ko'tarilgani markirovka talablarini bekor qilmaydi. Kompaniya QQS to'lamasa ham, markirovka qilingan tovarni chekda kod bilan sotishi va ulgurjida naqdsiz ishlashi shart. Ya'ni soliq rejimi yengillashdi, operatsion talab esa qattiqlashdi.",
        },

        { type: "h2", text: "Tekshiruv endi eshikdan emas, tizimdan keladi" },
        {
            type: "p",
            text:
                "2026-yil 1-yanvardan markirovka qoidalari buzilishini aniqlash bo'yicha tekshiruvlar masofadan, soliq organlari axborot tizimi orqali o'tkaziladi. Soliq qo'mitasi tarkibida markirovka nazorati bo'yicha Hududlararo soliq inspeksiyasi tashkil etildi.",
        },
        {
            type: "p",
            text:
                "Farqni tushunish muhim. Ilgari xatolik inspektor kelganda ochilardi va uni tushuntirish imkoni bor edi. Endi xatolik ma'lumotlar mos kelmagan zahoti ko'rinadi. 1-sentyabrdan esa markirovka qoidalarini buzish «yuqori» soliq riski omili hisoblanadi — bu kompaniyaning butun profiliga ta'sir qiladi.",
        },
        {
            type: "callout",
            text:
                "Amaliy xulosa: tizim ma'lumotni to'g'ri yuborishi kerak emas, balki har doim to'g'ri yuborishi kerak. Oyiga bir marta qo'lda tuzatiladigan hisobot bu talabni bajarmaydi.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Talablarga moslashish qancha turadi?" },
        {
            type: "p",
            text:
                "Aniq summa biznes hajmiga va hozir nimaga egalik qilayotganingizga bog'liq. Quyidagi oraliqlar — Innobek amaliyotidagi boshlang'ich narxlar.",
        },
        {
            type: "table",
            head: ["Ish", "Muddat", "Narx"],
            rows: [
                ["Bitta jarayonni avtomatlashtirish — masalan, kassa va ombor qoldig'i", "4–8 hafta", "15 mln so'mdan"],
                ["Distribyutor uchun CRM: to'lov, ESF va qarzdorlik nazorati", "6–10 hafta", "18 mln so'mdan"],
                ["Butun bo'lim uchun tizim", "3–5 oy", "45 mln so'mdan"],
                ["Ombor, sotuv, moliya va hisobotni yagona ERP ga yig'ish", "4–8 oy", "40 mln so'mdan"],
                ["Filiallari bor kompaniya uchun to'liq yechim", "6–12 oy", "110 mln so'mdan"],
                ["Ishga tushgandan keyingi qo'llab-quvvatlash", "oylik", "3,5 mln so'mdan / oyiga"],
            ],
        },
        {
            type: "p",
            text:
                "Narxga kirmaydigan qismlar: server va bulut to'lovlari, uchinchi tomon xizmatlari obunasi, 2D skaner va kassa uskunasi, xodimlarni o'qitish uchun ketadigan ish vaqti. Bularni byudjetda alohida qatorda ko'rsating.",
        },
        {
            type: "p",
            text:
                "Agar hozir ishlayotgan dasturingiz bor bo'lsa, birinchi qadam uni almashtirish emas. Avval yetkazib beruvchidan bitta savolga yozma javob oling: dastur markirovka kodini fiskal chekka uzata oladimi. Javob «ha» bo'lsa, byudjetning katta qismi kerak emas — faqat sozlash va o'qitish qoladi.",
        },

        { type: "h2", text: "Qaytim qanday hisoblanadi?" },
        {
            type: "p",
            text:
                "Qaytimni «tizim biznesni o'zgartiradi» degan gap bilan emas, soat bilan hisoblang. O'z raqamlaringizni quyidagi beshta qatorga qo'ying.",
        },
        {
            type: "ol",
            items: [
                "Buxgalter va operator markirovka kodlari, ESF va bank ko'chirmasini qo'lda solishtirishga oyiga necha soat sarflaydi? Aytaylik, 60 soat.",
                "Shu soatning tannarxi: oylik maosh ÷ 168. Masalan, 9 mln so'mlik maosh uchun bu taxminan 53 500 so'm.",
                "60 × 53 500 = 3,2 mln so'm — qo'l mehnatining oylik narxi.",
                "Tizim shu ishning 70% ini o'z ustiga oladi deb faraz qiling: oyiga taxminan 2,2 mln so'm tejaladi.",
                "15 mln so'mlik loyiha shu tejamning o'zi bilan taxminan 7 oyda qaytadi. Xatolik va jarima riskining kamayishi bu hisobga umuman kirmagan.",
            ],
        },
        {
            type: "p",
            text:
                "Agar sizda qo'lda solishtirishga oyiga 10 soat ketsa, hisob boshqacha chiqadi va tizim tezda o'zini oqlamaydi. Bu ham javob — shunda kichikroq yechim bilan boshlash kerak.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Hech narsa qilmaslikning narxi" },
        {
            type: "p",
            text:
                "Kutish ham qaror, va uning ham narxi bor. Faqat u byudjetda ko'rinmaydi, chunki keyinroq boshqa nom bilan keladi.",
        },
        {
            type: "list",
            items: [
                "«Yuqori» soliq riski toifasiga tushish — hujjatlaringizga e'tibor darajasi va so'rovlar soni ortadi.",
                "Chekda markirovka kodi bo'lmasa, tovarni qonuniy sotib bo'lmaydi — qoldiq omborda qoladi va pul muzlaydi.",
                "Ulgurjida naqd qabul qilishni davom ettirish bitimni rasmiylashtirish imkonini yo'qotadi.",
                "Shoshilinch moslashtirish har doim qimmat: talab kuchga kirgandan keyin muddat qisqaradi va ishlab chiquvchilar navbati to'ladi.",
                "Buxgalterning qo'lda tuzatishiga bog'liq jarayon shu odam ta'tilga chiqishi bilan to'xtaydi.",
            ],
        },

        { type: "h2", text: "Bu ish qachon sizga hozir kerak emas?" },
        {
            type: "p",
            text:
                "Halol javob: har bir kompaniyaga katta tizim kerak emas. Quyidagi holatlarda biz o'zimiz «hozir emas» deymiz.",
        },
        {
            type: "list",
            items: [
                "Markirovka qilinadigan tovar bilan umuman ishlamasangiz — kassa dasturini yangilash va ESF tartibini yo'lga qo'yish yetadi.",
                "Jarayonlaringiz yozilmagan bo'lsa — avtomatlashtirish tartibsizlikni tuzatmaydi, uni tezlashtiradi.",
                "Bir necha oyda biznes modelini o'zgartirmoqchi bo'lsangiz — hozir katta tizim qurish erta.",
                "Ichkarida tizimni yuritadigan mas'ul odam bo'lmasa — eng yaxshi dastur ham uch oyda tashlab qo'yiladi.",
                "Aylanmangiz kichik va oyiga o'nlab hujjat bo'lsa — qaytim hisobi ishlamaydi, oddiy jadval arzonroq.",
            ],
        },

        { type: "h2", text: "Olti haftalik amaliy reja" },
        {
            type: "ol",
            items: [
                "1-hafta: yuqoridagi jadval bo'yicha o'zingizga tegishli qatorlarni belgilang va mas'ul odamni tayinlang.",
                "2-hafta: hozirgi kassa va ombor dasturi markirovka kodini o'qiy oladimi — yetkazib beruvchidan yozma javob oling.",
                "3-hafta: ulgurji mijozlaringizni naqdsiz to'lovga o'tkazish uchun shartnomalarni qayta ko'rib chiqing.",
                "4-hafta: qo'lda solishtirishga ketayotgan soatlarni bir oy davomida o'lchang — qaytim hisobi shu raqamga tayanadi.",
                "5-hafta: ikkita variantni taqqoslang — mavjud dasturni moslashtirish yoki yangi tizim qurish.",
                "6-hafta: qaror qabul qiling va bosqichlarga bo'ling. Hammasini bir yo'la qilishga urinmang.",
            ],
        },
        {
            type: "p",
            text:
                "Eng keng tarqalgan xato — hammasini bitta katta loyiha qilib boshlash. Amalda birinchi bosqich odatda bitta jarayondan iborat bo'ladi: qoldiqni kod darajasida yuritish yoki to'lovlarni ESF bilan avtomatik solishtirish. Qolgani shundan keyin quriladi.",
        },
    ],

    faq: [
        {
            q: "Markirovka kodi chekda qachondan majburiy?",
            a: "2026-yil 1-iyuldan. ПП-190 qaroriga ko'ra markirovka qilingan tovar sotilganda uning kodi onlayn-KKM chekida aks etishi shart. Bu kassaga 2D skaner ulash va kassa dasturining kodni fiskal chekka uzata olishini talab qiladi. Dasturingiz buni qila oladimi — yetkazib beruvchidan yozma tasdiq so'rang.",
        },
        {
            q: "Ulgurjida naqd pul butunlay taqiqlanadimi?",
            a: "Taqiq markirovka qilinadigan mahsulot bilan ulgurji savdoga tegishli. 2026-yil 1-iyuldan bunday bitimlarda hisob-kitob faqat naqdsiz shaklda, bank hisob raqamlari orqali amalga oshiriladi. Ya'ni dilerlardan naqd qabul qilish modeli ishlamaydi va to'lovlarni bank ko'chirmasi hamda elektron hisob-faktura bilan solishtirish kerak bo'ladi. Amalda bu qarzdorlik nazoratini ham qayta qurishni talab qiladi.",
        },
        {
            q: "QQS chegarasi qancha bo'ldi?",
            a: "2026-yil 26-mayda imzolangan PF-100 farmoni bilan 1-iyundan umumiy soliq tizimiga o'tish chegarasi 1 mlrd so'mdan 12 000 BHM — taxminan 5 mlrd so'mgacha ko'tarildi. Bu ko'p kichik kompaniyani QQS majburiyatidan chiqaradi, lekin aylanmani muntazam kuzatib borish zaruratini olib tashlamaydi. Chegaraga yaqinlashayotganingizni yil oxirida emas, har oy ko'rib turishingiz kerak.",
        },
        {
            q: "«Yuqori soliq riski» nimani anglatadi?",
            a: "2026-yil 1-sentyabrdan markirovka qoidalarini buzish yuqori soliq riski omili hisoblanadi. Amalda bu kompaniyaning soliq organlari tizimidagi profiliga ta'sir qiladi: hujjatlaringizga e'tibor kuchayadi va so'rovlar soni ortadi. Buni oldini olishning yagona yo'li — ma'lumotning tizimdan doimiy va to'g'ri chiqishi. Bir marta tuzatilgan hisobot bu talabni bajarmaydi.",
        },
        {
            q: "Moslashtirish qancha vaqt oladi?",
            a: "Bitta jarayonni avtomatlashtirish odatda 4–8 hafta oladi va 15 mln so'mdan boshlanadi. Butun bo'lim uchun tizim 3–5 oy, ombor bilan moliyani birlashtiruvchi ERP esa 4–8 oy davom etadi. Muddatni qisqartirishning eng ishonchli yo'li — loyihani bosqichlarga bo'lish va eng og'riqli jarayondan boshlash.",
        },
        {
            q: "Mavjud 1C ni saqlab qolsa bo'ladimi?",
            a: "Ko'p holatda ha. 1C buxgalteriya konturi sifatida qoladi, ustiga esa sotuv, ombor va hujjat oqimi uchun tizim quriladi va integratsiya orqali ma'lumot almashadi. Bu hammasini noldan qurishdan sezilarli arzonroq tushadi va migratsiya riskini kamaytiradi. Yakuniy qaror 1C konfiguratsiyangiz qanchalik o'zgartirilganiga va integratsiya nuqtalari soniga bog'liq.",
        },
    ],

    cta: {
        h: "Qaysi talab aynan sizga tegishli — bepul aniqlaymiz",
        p:
            "Biznesingiz turini, tovar toifasini va hozirgi dasturlaringizni ko'rib chiqamiz, keyin tegishli sanalar ro'yxatini va taxminiy byudjetni beramiz. Hozir hech narsa qilish shart emas degan xulosaga kelsak, buni ham to'g'ridan-to'g'ri aytamiz.",
        button: "Bepul konsultatsiya olish",
    },

    images: [
        {
            src: "/assets/img/blog/raqamlashtirish-talablari-2026-cover.webp",
            alt: "2026-yilda biznesga tegishli to'rt muhim sana belgilangan kalendar va soliq muvofiqligi paneli",
            caption: "To'rt sana, bitta xulosa: qog'oz va Excel bilan hisobotni yopib bo'lmaydi",
            prompt:
                "Wide editorial illustration: a business owner's desk with a 2026 wall calendar where four dates are circled in red, next to a laptop showing a tax-compliance dashboard, a fiscal receipt printer and a stack of paper invoices being pushed aside; clean modern flat-vector style, blue and slate palette, no text labels, no brand logos, 16:9",
        },
        {
            src: "/assets/img/blog/raqamlashtirish-talablari-2026-taymlayn.webp",
            alt: "2026-yil bo'yicha talablar taymlayni: yanvar, iyun, iyul va sentyabr bosqichlari",
            caption: "Yanvar, iyun, iyul, sentyabr — talablar bir yilga tarqalgan",
            prompt:
                "Clean horizontal timeline infographic for the year 2026 with four milestone markers: January (remote tax inspections), June (VAT threshold raised), July (marking code in receipt, cashless wholesale), September (marking violation = high tax risk); minimal line style, blue accents, neutral background, no logos, 16:9",
        },
        {
            src: "/assets/img/projects/grandpharm.webp",
            alt: "Grandpharm uchun qurilgan boshqaruv tizimi — hujjat va yetkazib berish oqimi bitta ekranda",
            caption: "Talablarga tayyor tizim amalda shunday ko'rinadi: hujjat va yetkazish bitta oqimda",
        },
        {
            src: "/assets/img/blog/raqamlashtirish-talablari-2026-taqqoslash.webp",
            alt: "Qog'oz va Excel bilan ishlash hamda yagona tizimda ishlashning yonma-yon taqqoslanishi",
            caption: "Chapda — qo'lda solishtirish, o'ngda — bitta ekrandagi holat",
            prompt:
                "Side-by-side comparison illustration: left panel a cluttered desk with paper waybills, a calculator and a printed spreadsheet; right panel a single tablet screen showing structured order, e-invoice and marking-code status; flat vector, blue and warm grey, no text, 16:9",
        },
    ],

    relatedServices: ["biznes-avtomatlashtirish", "erp-tizimlar", "crm-tizimlar", "it-autsorsing"],
    relatedPosts: ["markirovka-kodi-chekda-2026", "ulgurji-savdo-naqdsiz-hisob-kitob", "shaxsiy-malumotlar-qonuni-sayt"],
};

const ru = {
    meta: {
        title: "Цифровизация бизнеса 2026: требования и даты в Узбекистане",
        description:
            "Четыре требования 2026 года: код маркировки в чеке, запрет наличных в опте, порог НДС и дистанционные проверки. Что делать, сколько стоит и когда окупится.",
        keywords: [
            "цифровизация бизнеса Узбекистан 2026 требования",
            "новые правила для бизнеса Узбекистан 2026",
            "порог НДС 12 000 БРВ",
            "обязательная цифровая маркировка ПП-190",
            "факторы налогового риска 2026",
            "электронная счёт-фактура обязательна",
        ],
    },
    h1: "Какие законы 2026 года заставляют бизнес перейти на цифровой учёт и во что это обходится",
    lead:
        "За один год вступили в силу четыре требования: код маркировки в чеке, запрет наличных в опте, новый порог НДС и дистанционные налоговые проверки. Разбираем, кого касается каждая дата, сколько стоит адаптация и как посчитать окупаемость на своих цифрах.",
    category: "Закон и комплаенс",
    readingTime: "9 минут",

    body: [
        {
            type: "p",
            text:
                "По отдельности каждое требование выглядит мелочью. Добавить строку в чек. Провести оплату через банк. Ещё раз проверить налоговый режим. Вместе они дают один вывод: закрыть отчётность бумажной тетрадью и таблицей Excel больше не получится.",
        },
        {
            type: "p",
            text:
                "Ниже — единая картина для собственника. Какая дата, кого касается, что нужно сделать и что будет, если не делать. Все цифры опираются на официальные документы, их названия указаны в таблице.",
        },

        { type: "h2", text: "Что изменилось в 2026 году и кого это касается?" },
        {
            type: "p",
            text:
                "Основной источник — постановление ПП-190 от 23 мая 2025 года. К нему добавилось изменение по налоговому режиму: указ ПФ-100, подписанный 26 мая 2026 года. Распечатайте таблицу и отметьте строки, которые относятся к вашему бизнесу.",
        },
        {
            type: "table",
            head: ["Дата", "Требование", "Кого касается", "Документ"],
            rows: [
                [
                    "1 января 2026",
                    "Нарушения маркировки выявляются дистанционно, через информационную систему налоговых органов. Создана Межрегиональная налоговая инспекция по контролю маркировки",
                    "Все, кто работает с маркируемым товаром",
                    "ПП-190",
                ],
                [
                    "1 июня 2026",
                    "Порог перехода на общий налоговый режим (НДС) поднят с 1 млрд сум до 12 000 БРВ — около 5 млрд сум",
                    "Компании с оборотом в диапазоне 1–5 млрд сум",
                    "ПФ-100 (26.05.2026)",
                ],
                [
                    "1 июня 2026",
                    "Кофе, цикорий и их экстракты включены в обязательную цифровую маркировку",
                    "Оптовая и розничная торговля продуктами",
                    "ПП-190",
                ],
                [
                    "1 июля 2026",
                    "Код маркировки обязателен в чеке онлайн-ККМ; в оптовой торговле расчёты только безналичные, через банковские счета",
                    "Розничные магазины, дистрибьюторы, оптовики",
                    "ПП-190",
                ],
                [
                    "1 сентября 2026",
                    "Нарушение правил маркировки считается фактором «высокого» налогового риска",
                    "Все перечисленные категории",
                    "ПП-190",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Три даты из четырёх касаются одного и того же процесса — пути товара от приёмки на склад до строки в чеке. То есть это вопрос не бухгалтерии, а операционной работы.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "1 июля: одна строка в чеке и исчезновение наличных" },
        {
            type: "p",
            text:
                "С 1 июля при продаже маркированного товара его код маркировки должен отражаться в чеке онлайн-кассы. На практике это означает 2D-сканер на кассе и кассовую программу, которая умеет передавать код в фискальный чек. У большинства старых программ такой функции нет.",
        },
        {
            type: "p",
            text:
                "Второе изменение тяжелее. В оптовой торговле маркируемой продукцией расчёты проводятся только в безналичной форме, через банковские счета. Для дистрибьютора, который годами принимал наличные от дилеров, это смена всей платёжной модели.",
        },
        {
            type: "list",
            items: [
                "Кассовая программа должна считывать код маркировки и добавлять его в строку чека.",
                "Складской остаток теперь ведётся не на уровне «100 штук», а на уровне каждого кода.",
                "Каждый оптовый платёж становится банковским переводом и должен сходиться с электронной счёт-фактурой.",
                "Остатки, которые раньше закрывались наличными, в отчётность уже не впишутся — их нужно привести в порядок заранее.",
            ],
        },

        { type: "h2", text: "Повышение порога НДС — это хорошая новость?" },
        {
            type: "p",
            text:
                "С 1 июня 2026 года порог перехода на общий налоговый режим поднят до 12 000 БРВ — примерно 5 млрд сум. Раньше плательщиком НДС становилась компания с оборотом выше 1 млрд сум. Теперь планка в пять раз выше.",
        },
        {
            type: "p",
            text:
                "Для многих небольших компаний это облегчение. Но учёт проще не становится. Если оборот приближается к порогу, его нужно видеть ежемесячно — узнать об этом от бухгалтера в конце года уже поздно. Именно поэтому система, показывающая оборот в реальном времени, из удобства превращается в необходимость.",
        },

        { type: "h2", text: "Проверка приходит не через дверь, а через систему" },
        {
            type: "p",
            text:
                "С 1 января 2026 года проверки по выявлению нарушений маркировки проводятся дистанционно, через информационную систему налоговых органов. В составе Налогового комитета создана Межрегиональная налоговая инспекция по контролю маркировки.",
        },
        {
            type: "p",
            text:
                "Разницу важно понять. Раньше ошибка вскрывалась при визите инспектора и её можно было объяснить. Теперь она видна в тот момент, когда данные перестали сходиться. А с 1 сентября нарушение правил маркировки считается фактором высокого налогового риска — это влияет на весь профиль компании.",
        },
        {
            type: "callout",
            text:
                "Практический вывод: система должна передавать данные не просто правильно, а правильно всегда. Отчёт, который раз в месяц вручную поправляет бухгалтер, этому требованию не отвечает.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Сколько стоит привести бизнес в соответствие?" },
        {
            type: "p",
            text:
                "Точная сумма зависит от масштаба и от того, что у вас уже есть. Ниже — стартовые цены из практики Innobek.",
        },
        {
            type: "table",
            head: ["Работа", "Срок", "Цена"],
            rows: [
                ["Автоматизация одного процесса — например, касса и складской остаток", "4–8 недель", "от 15 млн сум"],
                ["CRM для дистрибьютора: оплаты, ЭСФ и контроль задолженности", "6–10 недель", "от 18 млн сум"],
                ["Система для целого отдела", "3–5 месяцев", "от 45 млн сум"],
                ["Сведение склада, продаж, финансов и отчётности в единую ERP", "4–8 месяцев", "от 40 млн сум"],
                ["Полное решение для компании с филиалами", "6–12 месяцев", "от 110 млн сум"],
                ["Поддержка после запуска", "ежемесячно", "от 3,5 млн сум в месяц"],
            ],
        },
        {
            type: "p",
            text:
                "В цену не входят: оплата серверов и облака, подписки на сторонние сервисы, 2D-сканеры и кассовое оборудование, рабочее время сотрудников на обучение. Заложите это отдельной строкой бюджета.",
        },

        { type: "h2", text: "Как посчитать окупаемость?" },
        {
            type: "p",
            text:
                "Считайте не фразами вроде «система изменит бизнес», а часами. Подставьте свои цифры в пять строк ниже.",
        },
        {
            type: "ol",
            items: [
                "Сколько часов в месяц бухгалтер и оператор тратят на ручную сверку кодов маркировки, ЭСФ и банковской выписки? Допустим, 60 часов.",
                "Себестоимость часа: месячный оклад ÷ 168. При окладе 9 млн сум это примерно 53 500 сум.",
                "60 × 53 500 = 3,2 млн сум — месячная стоимость ручной работы.",
                "Допустим, система берёт на себя 70% этой работы: экономия около 2,2 млн сум в месяц.",
                "Проект за 15 млн сум окупается только на этой экономии примерно за 7 месяцев. Снижение риска ошибок и санкций в расчёт вообще не вошло.",
            ],
        },
        {
            type: "p",
            text:
                "Если на ручную сверку у вас уходит 10 часов в месяц, расчёт выйдет другим и система быстро себя не окупит. Это тоже ответ — значит, начинать нужно с решения поменьше.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Цена бездействия" },
        {
            type: "p",
            text:
                "Подождать — тоже решение, и у него есть стоимость. Просто она не видна в бюджете, потому что приходит позже и под другим названием.",
        },
        {
            type: "list",
            items: [
                "Попадание в категорию «высокого» налогового риска — растёт внимание к документам и число запросов.",
                "Без кода маркировки в чеке товар нельзя продать легально: остаток лежит на складе, деньги заморожены.",
                "Продолжать принимать наличные в опте — значит терять возможность оформить сделку.",
                "Срочная адаптация всегда дороже: после вступления требования в силу сроки сжимаются, а очередь у разработчиков растягивается.",
                "Процесс, который держится на ручных правках бухгалтера, останавливается вместе с его отпуском.",
            ],
        },

        { type: "h2", text: "Когда это вам пока не нужно?" },
        {
            type: "p",
            text:
                "Честный ответ: большая система нужна не каждой компании. В этих случаях мы сами говорим «пока не надо».",
        },
        {
            type: "list",
            items: [
                "Вы вообще не работаете с маркируемым товаром — достаточно обновить кассовую программу и наладить порядок с ЭСФ.",
                "Процессы не описаны — автоматизация не исправляет беспорядок, а ускоряет его.",
                "Через несколько месяцев вы планируете сменить бизнес-модель — строить крупную систему рано.",
                "Внутри нет ответственного, который будет вести систему: даже лучшая программа за три месяца оказывается заброшенной.",
                "Оборот небольшой, документов — десятки в месяц: расчёт окупаемости не сходится, обычная таблица дешевле.",
            ],
        },

        { type: "h2", text: "Практический план на шесть недель" },
        {
            type: "ol",
            items: [
                "Неделя 1: отметьте в таблице выше строки, которые касаются вас, и назначьте ответственного.",
                "Неделя 2: получите от поставщика письменный ответ, умеет ли текущая кассовая и складская программа считывать код маркировки.",
                "Неделя 3: пересмотрите договоры с оптовыми клиентами, чтобы перевести расчёты в безналичную форму.",
                "Неделя 4: измерьте реальные часы на ручную сверку за месяц — расчёт окупаемости опирается на эту цифру.",
                "Неделя 5: сравните два варианта — доработать текущую программу или строить новую систему.",
                "Неделя 6: примите решение и разбейте его на этапы. Не пытайтесь сделать всё сразу.",
            ],
        },
        {
            type: "p",
            text:
                "Самая частая ошибка — начинать одним большим проектом. На практике первый этап обычно состоит из одного процесса: учёт остатков на уровне кода или автоматическая сверка платежей с ЭСФ. Остальное строится уже поверх этого.",
        },
    ],

    faq: [
        {
            q: "С какого числа код маркировки обязателен в чеке?",
            a: "С 1 июля 2026 года. По постановлению ПП-190 при продаже маркированного товара его код должен отражаться в чеке онлайн-ККМ. Это требует 2D-сканера на кассе и кассовой программы, умеющей передавать код в фискальный чек. Запросите у поставщика программы письменное подтверждение такой возможности.",
        },
        {
            q: "Наличные в опте запрещены полностью?",
            a: "Запрет касается оптовой торговли маркируемой продукцией. С 1 июля 2026 года расчёты по таким сделкам проводятся только в безналичной форме, через банковские счета. Модель приёма наличных от дилеров перестаёт работать, а платежи придётся сверять с банковской выпиской и электронными счетами-фактурами. На практике это требует и перестройки контроля дебиторской задолженности.",
        },
        {
            q: "Каким стал порог НДС?",
            a: "Указом ПФ-100 от 26 мая 2026 года с 1 июня порог перехода на общий налоговый режим поднят с 1 млрд сум до 12 000 БРВ — около 5 млрд сум. Это выводит из-под НДС многие небольшие компании, но не снимает необходимости регулярно отслеживать оборот в течение года.",
        },
        {
            q: "Что означает «высокий налоговый риск»?",
            a: "С 1 сентября 2026 года нарушение правил маркировки считается фактором высокого налогового риска. На практике это влияет на профиль компании в системе налоговых органов: внимание к документам усиливается, число запросов растёт. Единственный способ этого избежать — чтобы данные уходили из системы стабильно и корректно.",
        },
        {
            q: "Сколько времени занимает адаптация?",
            a: "Автоматизация одного процесса обычно занимает 4–8 недель и начинается от 15 млн сум. Система для отдела — 3–5 месяцев, ERP, объединяющая склад и финансы, — 4–8 месяцев. Самый надёжный способ сократить срок — разбить проект на этапы и начать с самого болезненного процесса.",
        },
        {
            q: "Можно ли сохранить существующую 1С?",
            a: "В большинстве случаев да. 1С остаётся бухгалтерским контуром, а поверх строится система для продаж, склада и документооборота, обменивающаяся данными через интеграцию. Это заметно дешевле, чем делать всё заново, и снижает риски миграции. Итоговое решение зависит от того, насколько сильно доработана ваша конфигурация 1С и сколько точек интеграции потребуется.",
        },
    ],

    cta: {
        h: "Бесплатно определим, какие требования касаются именно вас",
        p:
            "Посмотрим тип бизнеса, категорию товара и текущие программы, затем назовём даты, которые касаются вас, и ориентировочный бюджет. Если придём к выводу, что сейчас ничего делать не нужно, скажем об этом прямо.",
        button: "Получить консультацию",
    },

    images: [
        {
            src: "/assets/img/blog/raqamlashtirish-talablari-2026-cover.webp",
            alt: "Календарь с отмеченными ключевыми датами 2026 года и панель налогового комплаенса",
            caption: "Четыре даты, один вывод: бумагой и Excel отчётность больше не закрыть",
            prompt:
                "Wide editorial illustration: a business owner's desk with a 2026 wall calendar where four dates are circled in red, next to a laptop showing a tax-compliance dashboard, a fiscal receipt printer and a stack of paper invoices being pushed aside; clean modern flat-vector style, blue and slate palette, no text labels, no brand logos, 16:9",
        },
        {
            src: "/assets/img/blog/raqamlashtirish-talablari-2026-taymlayn.webp",
            alt: "Таймлайн требований 2026 года: январь, июнь, июль и сентябрь",
            caption: "Январь, июнь, июль, сентябрь — требования растянуты на весь год",
            prompt:
                "Clean horizontal timeline infographic for the year 2026 with four milestone markers: January (remote tax inspections), June (VAT threshold raised), July (marking code in receipt, cashless wholesale), September (marking violation = high tax risk); minimal line style, blue accents, neutral background, no logos, 16:9",
        },
        {
            src: "/assets/img/projects/grandpharm.webp",
            alt: "Система управления Grandpharm — документооборот и доставка в одном экране",
            caption: "Так выглядит система, готовая к требованиям: документы и доставка в одном потоке",
        },
        {
            src: "/assets/img/blog/raqamlashtirish-talablari-2026-taqqoslash.webp",
            alt: "Сравнение работы на бумаге и в Excel с работой в единой системе",
            caption: "Слева — ручная сверка, справа — статус на одном экране",
            prompt:
                "Side-by-side comparison illustration: left panel a cluttered desk with paper waybills, a calculator and a printed spreadsheet; right panel a single tablet screen showing structured order, e-invoice and marking-code status; flat vector, blue and warm grey, no text, 16:9",
        },
    ],

    relatedServices: ["biznes-avtomatlashtirish", "erp-tizimlar", "crm-tizimlar", "it-autsorsing"],
    relatedPosts: ["markirovka-kodi-chekda-2026", "ulgurji-savdo-naqdsiz-hisob-kitob", "shaxsiy-malumotlar-qonuni-sayt"],
};

const content = { uz, ru };

export default content;
